import { createAction } from 'redux-actions'

import * as constants from './constants'

export const requestBulkUpdate = createAction(constants.REQUEST_BULK_UPDATE)
export const requestBulkUpdatePending = createAction(constants.REQUEST_BULK_UPDATE_PENDING)
export const requestBulkUpdateFailed = createAction(constants.REQUEST_BULK_UPDATE_FAILED)
export const requestBulkUpdateSuccess = createAction(constants.REQUEST_BULK_UPDATE_SUCCESS)

export const receiveBulkUpdate = createAction(constants.RECEIVE_BULK_UPDATE)
export const receiveBulkUpdatePending = createAction(constants.RECEIVE_BULK_UPDATE_PENDING)
export const receiveBulkUpdateFailed = createAction(constants.RECEIVE_BULK_UPDATE_FAILED)
export const receiveBulkUpdateSuccess = createAction(constants.RECEIVE_BULK_UPDATE_SUCCESS)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/conversation/bulkUpdate/actions.js